/**
 * Ist das Gerät ein Apple-Gerät? Die eine Stelle, die dafür `navigator` liest.
 *
 * iPadOS meldet sich seit Version 13 als „Macintosh"; erkennbar bleibt es nur
 * daran, dass ein Mac keine Berührungspunkte hat. Genau diese Heuristik stand
 * zweimal im Baum — und eine Browser-Heuristik ändert sich erfahrungsgemäß,
 * wer den einen Ort nachzieht, findet den anderen nicht (`docs/aufraeumen.md`).
 *
 * Zwei Aufrufer mit verschiedenen Ansprüchen, deshalb heißt sie nur „Apple-Gerät"
 * und nicht „iOS-Safari":
 *
 *  - `erkennePlattform` (`src/features/mobile/navigationsZiel.ts`) nimmt die
 *    Antwort roh. Ein Fehlgriff ist dort kein Beinbruch: auf einem echten Mac
 *    öffnet `maps.apple.com` dieselbe Karte im Browser.
 *  - `useInstallPrompt` (`src/lib/pwa/`) engt danach zusätzlich auf Safari ein,
 *    weil „Zum Home-Bildschirm" nur dort existiert.
 */
export function istAppleGeraet(): boolean {
  if (typeof navigator === "undefined") return false;
  const kennung = navigator.userAgent || "";
  if (/iPhone|iPad|iPod/.test(kennung)) return true;
  return /Macintosh/.test(kennung) && navigator.maxTouchPoints > 1;
}
